/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext } from 'react';
import { Grid, Box, Tooltip, Typography, Stack, IconButton } from '@mui/material';
import { IoDocumentTextOutline, IoClose } from 'react-icons/io5';
import { RiDeleteBinLine } from 'react-icons/ri';
import ReactPlayer from 'react-player';
import { formatBytes } from '../../../../../../../../libs/HelperContent';
import { createFeedContext } from '../..';
import ReactDOM from 'react-dom';
import { LanguageContext } from '../../../../../../../../libs/Context';

const UploadImages = (props) =>
{
	const { mediaData, excludedS3KeysRef } = props;
	const { setCreateFeed, createFeed } = useContext(createFeedContext);
	const { language } = useContext(LanguageContext);

	const handleRemoveFromS3 = async (key:any) =>
	{
		const removedItems = createFeed?.media?.filter((item:any) =>
		{
			if (item?.key === key)
			{
				excludedS3KeysRef.current.push(item?.key);

				return false;
			}

			return true;
		});

		// update local state...
		setCreateFeed((prev) => ({ ...prev, media: removedItems }));
	};

	const renderTrashIcon = (mediaD, fileType) =>
	{
		return (
			<Box
				onClick={(e) => { handleRemoveFromS3(mediaD?.key); }}
				// className='trash-icon'
				sx={{
					position        : 'absolute',
					top             : 'var(--pixel8)',
					right           : 'var(--pixel8)',
					width           : 'var(--pixel32)',
					height          : 'var(--pixel32)',
					cursor          : 'pointer',
					backgroundColor : 'var(--whiteColor)',
					borderRadius    : 'var(--percent50)',
					display         : 'flex',
					alignItems      : 'center',
					justifyContent  : 'center',
					transition      : 'opacity 0.3s ease',
					boxShadow       : '0px 0px 5px rgba(0, 0, 0, 0.3)'
					// opacity         : fileType === 'video' ? 1 : 0,
					// '&:hover'       : {
					// 	opacity : 1
					// }
				}}
			>
				<Tooltip title={language?.delete} placement='top'>
					<IconButton>
						<RiDeleteBinLine size={20} />
					</IconButton>
				</Tooltip>
			</Box>
		);
	};

	const renderDocView = (index, mediaD) =>
	{
		return (
			<Grid item xs={12} sm={6} lg={6} p={1} key={index}>
				<Grid container direction={'row'} px={2} py='6px' alignItems='center'
					sx={{
						backgroundColor : '#fff',
						borderRadius    : '32px',
						boxShadow       : '0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)'
					}}
				>
					<Grid item>
						<Box
							component='img'
							src='/documents/pdf.png'
							width={'var(--pixel24)'}
							height={'var(--pixel24)'}
						/>
						{/* <Box >
							<IoDocumentTextOutline fontSize='var(--pixel24)' />
						</Box> */}

					</Grid>
					<Grid item xs minWidth={0} pl={1}>
						<Stack direction={'column'} width={'100%'}>
							<Typography
								sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
								maxWidth='100%'
							>
								{mediaD?.name}
							</Typography>
							<Typography variant='body2'>{formatBytes(mediaD?.size)}</Typography>
						</Stack>
					</Grid>
					<Grid item onClick={() => handleRemoveFromS3(mediaD?.key)}>
						<IoClose fontSize='20px' style={{ cursor: 'pointer' }} />
					</Grid>
				</Grid>
			</Grid>
		);
	};

	return (
		<Grid container spacing={2} py='var(--pixel16)'>
			<div id='documentView' style={{ width: '100%', display: 'flex', flexWrap: 'wrap' }}/>
			{mediaData?.length > 0 && mediaData?.map((mediaD, index) =>
			{
				if (mediaD?.type === 'link') return <></>;
				const fileType:any = mediaD && mediaD?.type && mediaD?.type?.split('/')[0];
				let extensionformat = mediaD && mediaD?.key?.split('.').pop();

				extensionformat = extensionformat || (mediaD?.fileType === 'image' ? 'jpg' : fileType === 'video' ? 'mp4' : 'doc');

				return (
					(fileType === 'video' || mediaD?.type === 'youtube')
						? <div className='flexRow pdngXS resourceCard16x9'>
							<div className='feedVideoItem baseBg brdrRadiusSM positionRelative resourceCard16x9' >
								<ReactPlayer url={mediaD?.url} className='reactPlayerWidth' width={'var(--percent100)'} height={'var(--percent100)'} controls/>
								{renderTrashIcon(mediaD, fileType)}
							</div>
						</div>
						: fileType === 'application'
							? document?.getElementById('documentView')
								? ReactDOM.createPortal(renderDocView(index, mediaD), document.getElementById('documentView') as HTMLElement)
								: renderDocView(index, mediaD)
							: (
								<Grid
									item
									xs={12}
									sm={6}
									key={index}
									sx={{ position: 'relative', width: '100%' }}
								>
									<Box
										sx={{
											position : 'relative',
											width    : '100%'
											// '&:hover .trash-icon' : {
											// 	opacity : 1
											// }
										}}
									>
										<Box
											component='img'
											src={fileType === 'image' ? `${mediaD?.url}?t=${new Date()?.valueOf()}` : `/documents/${extensionformat}.png`}
											alt={`Uploaded ${index}`}
											sx={{
												width        : '100%',
												borderRadius : '13px',
												height       : '150px',
												objectFit    : 'cover',
												border       : '1px solid rgba(0,0,0,0.12)'
											}}
										/>

										{renderTrashIcon(mediaD, fileType)}
									</Box>
								</Grid>
							)

				);
			})}
		</Grid>
	);
};

export default UploadImages;
